import styled from "styled-components";

export const Container = styled.footer`
  margin-top: 8rem;
  padding: 3rem 10rem;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  background: var(--bg-surface);
  border-top: 1px solid var(--bg-border);

  .light & {
    background: var(--bg-surface);
    border-top-color: rgba(136, 57, 239, 0.1);
    color: var(--text-primary);
  }

  /* ── Text Logo ── */
  .logo {
    display: flex;
    align-items: center;
    text-decoration: none;

    .logo-text {
      font-family: var(--font-heading);
      font-size: 2.2rem;
      font-weight: 800;
      color: var(--text-primary);
      letter-spacing: -0.04em;
      transition: opacity 0.2s ease;

      .logo-dot {
        color: var(--accent-mauve);
      }
    }

    &:hover .logo-text { opacity: 0.75; }
  }

  .center-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;

    /* "Back to top" button */
    .back-to-top {
      display: inline-flex;
      align-items: center;
      gap: 0.6rem;
      background: rgba(198, 160, 246, 0.08);
      border: 1px solid rgba(198, 160, 246, 0.18);
      color: var(--text-muted);
      border-radius: 6px;
      padding: 0.6rem 1.4rem;
      font-family: var(--font-code);
      font-size: 1.2rem;
      font-weight: 500;
      letter-spacing: 0.04em;
      cursor: pointer;
      transition: all 0.2s ease;

      svg { flex-shrink: 0; }

      &:hover {
        border-color: var(--accent-mauve);
        color: var(--accent-mauve);
        background: rgba(198, 160, 246, 0.12);
        transform: translateY(-2px);
      }

      .light & {
        background: rgba(136, 57, 239, 0.06);
        border-color: rgba(136, 57, 239, 0.15);
        color: var(--text-muted);

        &:hover {
          border-color: var(--accent-mauve);
          color: var(--accent-mauve);
        }
      }
    }

    p {
      font-family: var(--font-code);
      font-size: 1.15rem;
      color: var(--text-faint);
      letter-spacing: 0.04em;
    }
  }

  .social-media {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border-radius: 8px;
      background: rgba(198, 160, 246, 0.06);
      border: 1px solid rgba(198, 160, 246, 0.12);
      transition: all 0.2s ease;
      overflow: hidden;

      img {
        width: 2rem;
        height: 2rem;
        /* Use natural SVG colors — LinkedIn blue, GitHub, WhatsApp green
           all read well against both light and dark surfaces */
        opacity: 0.85;
        transition: opacity 0.2s ease, transform 0.2s ease;
        object-fit: contain;
      }

      &:hover {
        background: rgba(198, 160, 246, 0.14);
        border-color: var(--accent-mauve);
        transform: translateY(-2px);
        img { opacity: 1; transform: scale(1.1); }
      }
    }
  }

  @media (max-width: 1200px) {
    padding: 3rem 5rem;
  }

  @media (max-width: 740px) {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
    padding: 2.5rem 2.5rem;
    text-align: center;

    .social-media { justify-content: center; }
  }

  @media (max-width: 480px) {
    padding: 2.5rem 1.8rem;
  }
`;
